"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminFiltersComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const notification_service_1 = require("./notification.service");
const filter_metric_service_1 = require("./filter-metric.service");
const permission_service_1 = require("./permission.service");
const clients_service_1 = require("./clients.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const data_source_service_1 = require("./data-source.service");
let AdminFiltersComponent = class AdminFiltersComponent {
    constructor(_talk, _admin, _filterMetric, _bidFilters, _permission, _clients, _dataSource) {
        this._talk = _talk;
        this._admin = _admin;
        this._filterMetric = _filterMetric;
        this._bidFilters = _bidFilters;
        this._permission = _permission;
        this._clients = _clients;
        this._dataSource = _dataSource;
        this.filterMetrics = new Array();
        this.filterSearchTerm = '';
        this.loadingData = false;
        this.dataRequestFailed = false;
        this.activeTabs = new Map();
        this.filtersDataSourcesMap = new Map();
        this.dateRange = {
            start: moment().startOf('day').format("YYYY-MM-DD HH:MM:SS"),
            end: moment().startOf('day').format("YYYY-MM-DD HH:MM:SS")
        };
    }
    ngOnInit() {
        this.loadInitData();
    }
    loadInitData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.permission = this._permission.get();
            try {
                this.loadingData = true;
                // TODO: Lazy load clients based on the current data source instead of pulling all 
                this.clients = (yield this._clients.pullAll()) || [];
                this.rtbClients = (yield this._bidFilters.pullRTBPublishers()) || [];
                const metricTypes = (yield this._filterMetric.pull()) || [];
                // parse types to construct a map of filter types data sources and values
                this.filtersDataSourcesMap = this._filterMetric.buildFiltersTypeSourcesMap(metricTypes);
                this.loadingData = false;
            }
            catch (err) {
                this.loadingData = false;
                this.dataRequestFailed = true;
                // console.warn('Unable to get some of filters data', err.message);
            }
        });
    }
    onFilterTypeClick($event, filterType, dataSource) {
        $event.preventDefault();
        this.activeTabs.set(dataSource.slug, filterType.slug);
    }
    getCustomFilterClass(filterType, dataSource) {
        const customClasses = {};
        if (this.isActiveFilterType(dataSource, filterType))
            customClasses['activeFilter'] = true;
        return customClasses;
    }
    isActiveFilterType(dataSource, filterType) {
        return (this.activeTabs.get(dataSource.slug) === filterType.slug);
    }
    isActiveFilterSource(dataSource) {
        return !!this.activeTabs.get(dataSource.slug);
    }
    setDateRange(e) {
        this.dateRange.start = e.picker ? moment(e.picker.startDate).startOf('hour').format("YYYY-MM-DD HH:mm:ss") : moment(e.start).startOf('hour').format("YYYY-MM-DD HH:mm:ss");
        this.dateRange.end = e.picker ? moment(e.picker.endDate).startOf('hour').format("YYYY-MM-DD HH:mm:ss") : moment(e.end).startOf('hour').format("YYYY-MM-DD HH:mm:ss");
    }
    populateFilterMetrics() {
        Promise.resolve(this._admin.populateFilterMetrics(this.dateRange)).then(res => {
            this._talk.broadcast('Running Filter Metrics Population job');
        });
    }
    reloadInitState() {
        this.filterSearchTerm = '';
        this.loadInitData();
        // any other resets ...
    }
    dataSourceClients(dataSource = '') {
        if (this._dataSource.isServerSideOrDealsOrConnect(dataSource)) {
            return this.parseClients(this.rtbClients || []);
        }
        return this.clients || [];
    }
    parseClients(clients = []) {
        return clients.map(client => {
            return {
                name: client.name || client.displayName || `NO_NAME (${client.id})`,
                id: client.id
            };
        });
    }
};
exports.AdminFiltersComponent = AdminFiltersComponent;
exports.AdminFiltersComponent = AdminFiltersComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-dashboard-filters',
        templateUrl: 'app/admin-dashboard-filters.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        filter_metric_service_1.FilterMetricService,
        bid_data_filter_service_1.BidDataFilterService,
        permission_service_1.PermissionService,
        clients_service_1.ClientsService,
        data_source_service_1.DataSourceService])
], AdminFiltersComponent);
//# sourceMappingURL=admin-dashboard-filters.component.js.map